var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDefaultEmptyStateView = function SvgDefaultEmptyStateView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 487.943 421.088"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Default-Empty-State-View_svg__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff177e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6a38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Default-Empty-State-View_svg__linear-gradient-10",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Default-Empty-State-View_svg__clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Default-Empty-State-View_svg__fill"
  })), /*#__PURE__*/React.createElement("style", null, ".Default-Empty-State-View_svg__cls-1,.Default-Empty-State-View_svg__cls-6{fill:#bdd8f7}.Default-Empty-State-View_svg__cls-10,.Default-Empty-State-View_svg__cls-2,.Default-Empty-State-View_svg__cls-3{fill:url(#Default-Empty-State-View_svg__linear-gradient)}.Default-Empty-State-View_svg__cls-3{opacity:.2}.Default-Empty-State-View_svg__cls-7{fill:#fff}.Default-Empty-State-View_svg__cls-10,.Default-Empty-State-View_svg__cls-11,.Default-Empty-State-View_svg__cls-13,.Default-Empty-State-View_svg__cls-17,.Default-Empty-State-View_svg__cls-19,.Default-Empty-State-View_svg__cls-6,.Default-Empty-State-View_svg__cls-7,.Default-Empty-State-View_svg__cls-8,.Default-Empty-State-View_svg__cls-9{fill-rule:evenodd}.Default-Empty-State-View_svg__cls-8{fill:rgba(38,50,56,.19)}.Default-Empty-State-View_svg__cls-9{fill:url(#Default-Empty-State-View_svg__linear-gradient-10)}.Default-Empty-State-View_svg__cls-11{fill:#002653}.Default-Empty-State-View_svg__cls-13{fill:#6520a2}.Default-Empty-State-View_svg__cls-17{fill:#5c5c5c}.Default-Empty-State-View_svg__cls-19{fill:rgba(38,50,56,.11)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Connecting_Youth_-_Illustration",
    transform: "translate(-175.374 -1360.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Rectangle_875",
    d: "M10 0h173.667a10 10 0 0110 10v23.16a10 10 0 01-10 10H0V10A10 10 0 0110 0z",
    className: "Default-Empty-State-View_svg__cls-1",
    transform: "translate(304.375 1360.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Rectangle_876",
    d: "M10 0h96.2a10 10 0 0110 10v22.093H10a10 10 0 01-10-10V10A10 10 0 0110 0z",
    className: "Default-Empty-State-View_svg__cls-1",
    transform: "translate(427.215 1416.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart",
    d: "M20.814 3.938h-.057a6.527 6.527 0 00-5.45 2.983 6.527 6.527 0 00-5.45-2.983H9.8a6.486 6.486 0 00-6.425 6.482 13.964 13.964 0 002.742 7.612 48.054 48.054 0 009.19 8.852 48.054 48.054 0 009.19-8.852 13.964 13.964 0 002.742-7.612 6.486 6.486 0 00-6.425-6.482z",
    className: "Default-Empty-State-View_svg__cls-2",
    transform: "translate(628.277 1573.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-2",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(636.155 1539.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-3",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(628.277 1531.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-4",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(643.956 1509.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-5",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(632.197 1486.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-6",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(636.117 1468.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-7",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(632.197 1441.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Icon_ionic-ios-heart-8",
    d: "M15.058 3.938h-.038a4.373 4.373 0 00-3.651 2 4.373 4.373 0 00-3.651-2h-.039a4.345 4.345 0 00-4.3 4.343 9.355 9.355 0 001.837 5.1 32.191 32.191 0 006.156 5.93 32.191 32.191 0 006.156-5.93 9.355 9.355 0 001.837-5.1 4.345 4.345 0 00-4.307-4.343z",
    className: "Default-Empty-State-View_svg__cls-3",
    transform: "translate(643.956 1415.195)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2881",
    transform: "translate(291.095 1479.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Default-Empty-State-View_svg__Rectangle_877",
    width: 47.587,
    height: 18.813,
    className: "Default-Empty-State-View_svg__cls-2",
    rx: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "Default-Empty-State-View_svg__LIVE",
    fill: "#fff",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: 700,
    transform: "translate(9.96 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LIVE"))), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2837",
    transform: "translate(175.984 1372.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_556",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#126bd5",
    strokeMiterlimit: 35.778,
    strokeWidth: 9.391,
    d: "M95.668 91.639h328.23v184.724H95.668z",
    opacity: 0.534
  }), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2814",
    transform: "translate(401.719 231.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_625",
    d: "M658.612 351.581a38.978 38.978 0 11-38.979 38.978 38.993 38.993 0 0138.979-38.978z",
    className: "Default-Empty-State-View_svg__cls-6",
    transform: "translate(-619.633 -351.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_626",
    d: "M671.088 401.962l1.684 14.656a13.351 13.351 0 01-6.638 1.659 19.724 19.724 0 01-7.954-1.785l.5-5.55h.19c9.204.002 12.218-8.98 12.218-8.98z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-623.91 -357.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_627",
    d: "M652.09 386.249l13.6 1.309 1.309 1.56s-3.8 9.728 3.3 11.1c0 0-2.826 9.554-13 9.554q-.769 0-1.592-.075s-2.806-1-3.868-5.425a46.3 46.3 0 01.251-18.023z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-623.124 -355.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_628",
    d: "M671.1 401.962c-1.843 12.253-11.8 12.537-12.716 12.537h-.068l.312-2.867c10.231-1.188 12.472-9.669 12.472-9.67z",
    className: "Default-Empty-State-View_svg__cls-8",
    transform: "translate(-623.926 -357.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_629",
    d: "M648.229 370.537c.819 2.182 3.295 3.369 8.25 3.369a51.34 51.34 0 006.593-.5 19.434 19.434 0 012.622-.19c7.088 0 7.794 4.743 7.794 4.743 5.051.438 3.929 4.678 3.929 4.678a2.774 2.774 0 01.628-.073 3.608 3.608 0 012.8 1.818 2.9 2.9 0 00-1.183-.3c-1.222 0-1.788 1.211-1.935 2.918a9.942 9.942 0 01-1.87 4.865c-.584.95-.094 1.192.552 1.192a6.186 6.186 0 001.5-.258 8.014 8.014 0 01-7.942 5.693c-.3 0-.478-.017-.478-.017l-3.366-11.1s-1.185-1.5-8.545-1.5c-7.3-.063-7.921-.063-11.85-3.992-3.99-3.99-.5-10.164-.5-10.166a2.752 2.752 0 002.557 3.119 4.138 4.138 0 01.444-4.299z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-622.318 -353.685)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_630",
    d: "M662.845 372.962a8.883 8.883 0 016.624 2.583c4.614 4.74 4.179 9.728 4.179 9.728l-2.932-.375s-.153-10.687-9.061-10.687a13.769 13.769 0 00-2.913.335l-1.684-.436a16.291 16.291 0 015.787-1.148z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-623.788 -353.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_631",
    d: "M649.937 386.671a4.512 4.512 0 001.684.561 37.122 37.122 0 00-.748 9.1c-.687-.063-2.62-2.681-2.308-5.613a7.694 7.694 0 011.372-4.048z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-622.842 -355.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_632",
    d: "M671.906 385.884a4.111 4.111 0 01.781.075c2.93.561 4.677 4.178 3.929 8.045-.678 3.573-3.244 6.113-5.892 6.113h-.1a10.18 10.18 0 01-8.794 6.486 1.14 1.14 0 01-1.122.811l-1.745-.187a1.129 1.129 0 01.131-2.251c.038 0 .078 0 .119.005l1.747.187a1 1 0 01.685.312 8.874 8.874 0 007.733-5.175c.063-.126.063-.251.125-.375-2.62-.811-4.178-4.241-3.431-7.921.684-3.58 3.179-6.125 5.834-6.125z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-623.888 -355.387)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2816",
    transform: "translate(140.455 124.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_559",
    d: "M464.078 376.136c-21.827.936-29.436 11.349-34.237 15.155-4.741 3.8-39.852 18.024-45.527 19.021-5.738.936-7.609 2.806-11.412 7.609-3.805 4.74-17.088 19.894-20.893 33.179-3.8 13.345-1.808 70.723-1.808 70.723h230.751s2-57.377-1.809-70.723c-3.8-13.284-17.088-28.439-20.831-33.179-3.741-4.8-5.674-6.673-11.412-7.609-5.676-1-40.786-15.218-45.588-19.021s-12.348-14.219-34.176-15.155z",
    className: "Default-Empty-State-View_svg__cls-11",
    transform: "translate(-349.676 -236.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_560",
    d: "M429.854 393.182l-1.384.922a12.976 12.976 0 001.384-.922zm-1.384.922c-8.032 4.769-38.858 17.17-44.143 18.1-5.738.936-7.609 2.806-11.412 7.609-3.805 4.74-17.088 19.895-20.893 33.179-2.681 9.417-2.369 48.52-1.933 70.723h2.12c2.5-21.454 6.8-58.125 7.36-63.365.81-7.421 8.3-21.578 12.474-26.567s6.671-10.79 17.457-15.783c9.342-4.339 33-19.932 38.97-23.9z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-349.687 -238.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_561",
    d: "M490.55 218.727a9.415 9.415 0 01-3.492 7.234 19.354 19.354 0 01-7.422 3.491c-7.483 2.059-15.4 2.121-22.826 4.429a19.952 19.952 0 00-6.859 3.305 15.071 15.071 0 00-5.55 12.784c.124 2 .873 3.493-.249 5.3-1.248 2-3.493 3.68-4.928 5.552a47.484 47.484 0 00-9.542 28.5c0 1.248.063 2.494.126 3.68 0 0-15.467.124-15.779 18.148h-.5v-14.217a2.37 2.37 0 10-4.74 0v14.906a2.4 2.4 0 00-.936 2.182v13.284c0 1.87.936 4.74 3.8 4.74h6.362c4.3 10.851 10.227 11.412 14.531 11.412 5.676 0 6.61 0 10.415-2.869l.124-.124 2.932 25.321 55.068 2.182 4.553-30.247v-.063l2.059 2.93c3.8 2.806 4.74 2.806 10.415 2.806 4.3 0 10.227-.5 14.531-11.35h6.237c2.868 0 3.8-2.869 3.8-4.74v-13.282a2.582 2.582 0 00-1.185-2.371h.249v-15.215a2.37 2.37 0 00-4.74 0v14.717h-.373C536.327 293.128 520.86 293 520.86 293l-.187.249c.124-1.248.187-2.62.187-3.929a46.921 46.921 0 00-10.623-29.862c2.309-6.235.746-15.516-3.16-21.714-1.372-2.182-2.806-5.988-5.426-10.1-2.307-3.679-6.86-8.044-11.101-8.917z",
    className: "Default-Empty-State-View_svg__cls-11",
    transform: "translate(-356.125 -218.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_562",
    fill: "#022653",
    fillRule: "evenodd",
    d: "M474.5 242.576c-12.286 0-20.891 3.805-21.828 4.8-.436.375 0 1.06.624 1.684-5.613 3.305-28.5 17.275-37.606 30.559-6.673 9.479-5.738 15.218-5.738 19.021l3.118-.748a26.6 26.6 0 015.489-16.34c6.61-8.606 12.348-16.152 30.434-27.44l7.173-4.3a46.919 46.919 0 0118.46-4.3h.4a47.736 47.736 0 0120.932 4.865l.186-.124 6.486 3.929c18.085 11.226 23.823 18.835 30.433 27.378a26.782 26.782 0 015.489 16.4l3.119.685c-.063-3.8.871-9.542-5.8-19.021-9.354-13.595-33.177-27.939-38.042-30.808.5-.5.811-1.06.436-1.435-.937-.999-11.415-4.805-23.765-4.805z",
    transform: "translate(-356.354 -221.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_563",
    d: "M481.79 376.136s24.509 3.43 28.687 16.713c.749 2.494 3.118 4.49 5.8 5.8 6.673 3.305 30.746 14.156 40.723 17.461 7.485 2.494 10.79 5.8 13.284 9.106 2.494 3.368 12.472 17.463 15.779 26.63 3.368 9.23 7.421 47.086 8.792 69.975h.75c.5-22.2.873-61.306-1.81-70.723-3.8-13.284-17.088-28.439-20.891-33.179-3.742-4.8-5.676-6.673-11.351-7.609-5.737-1-40.786-15.218-45.588-19.021s-12.347-14.216-34.175-15.153z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-364.329 -236.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_564",
    d: "M509.356 250.082l.2.124-.2-.124zm.2.124c2.414 1.5 26.07 16.386 35.536 29.813 8.231 11.662 7.483 19.895 7.483 19.895s2-9.356-6.049-20.02c-8.014-10.626-19.618-18.96-36.969-29.689z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-367.387 -222.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_565",
    d: "M556.074 303.325c1.684 2.494 2.12 17.461 2.12 17.461V306.38c0-2.806-2.12-3.055-2.12-3.055z",
    className: "Default-Empty-State-View_svg__cls-13",
    transform: "translate(-372.569 -228.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_566",
    d: "M552.357 322.964a11.858 11.858 0 014.178.811 3.039 3.039 0 011.621 2.5l.873 12.472-.312-12.66a2.488 2.488 0 00-2.182-3.118z",
    className: "Default-Empty-State-View_svg__cls-13",
    transform: "translate(-372.159 -230.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_567",
    d: "M535.632 302.431a5.674 5.674 0 00-.743.045s5.363 0 6.549 6.3c1.185 6.361-1.185 22.764-6.549 37.295 0 0 3.992-5.427 6.8-17.337a67.846 67.846 0 001.621-21.578 13.749 13.749 0 015.862 10.29c.438 6.985-.249 14.032-2.557 23.949 0 0 4.8-11.787 3.929-23.825a16.026 16.026 0 00-14.912-15.139z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-370.218 -228.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_568",
    d: "M453.27 249.731s-2.9 1.726-7.126 4.544q3.42-2.204 7.126-4.544zm-7.126 4.544c-13.724 8.846-24 16.265-30.793 25.516-7.984 10.79-5.238 20.083-5.238 20.083s-1.5-8.3 6.61-20.02c6.61-9.538 20.796-19.833 29.421-25.579z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-356.328 -222.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_572",
    d: "M537.2 311.881s-1.435 16.9-6.8 31.683a78.6 78.6 0 005.613-15.716 59.615 59.615 0 001.187-15.967z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-369.721 -229.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_569",
    fill: "#0092a1",
    fillRule: "evenodd",
    d: "M410.754 303.815s-2.059.249-2.059 3.056l.188 14.407s.25-14.969 1.871-17.463z",
    transform: "translate(-356.22 -228.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_570",
    d: "M413.867 322.9h-.3zm-.3 0l-3.818.057c-.873 0-2.494.811-2.182 3.119l.249 13.534.249-13.345a2.9 2.9 0 011.684-2.5 10.453 10.453 0 013.82-.865z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-356.091 -230.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_571",
    d: "M429.89 302.162a15.925 15.925 0 00-14.822 15.253c-.811 12.036 4.178 23.761 4.178 23.761-2.495-9.791-3.242-16.839-2.869-23.886a13.624 13.624 0 015.8-10.352 67.555 67.555 0 001.808 21.517c2.932 11.974 6.985 17.275 6.985 17.275-5.55-14.468-8.045-30.808-6.922-37.171s6.486-6.361 6.486-6.361a5.653 5.653 0 00-.644-.036z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-356.918 -227.983)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_583",
    fill: "#f90",
    fillRule: "evenodd",
    d: "M326.509 239.146a6.738 6.738 0 01-2.514.838 55.429 55.429 0 011.117 13.594c1.025-.094 3.912-4 3.446-8.381a11.49 11.49 0 00-2.049-6.051z",
    transform: "translate(-242.971 -177.109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2034-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_624",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#bdd8f7",
    strokeMiterlimit: 35.778,
    strokeWidth: 1.22,
    d: "M123.582 64.066c0 35.29-27.681 63.972-61.836 63.972C27.684 128.038 0 99.356 0 64.066 0 28.68 27.684 0 61.746 0c34.155.002 61.836 28.679 61.836 64.066z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_625-2",
    d: "M675.808 351.581c-31.008 0-56.174 26.074-56.174 58.2s25.166 58.2 56.174 58.2 56.174-26.071 56.174-58.2-25.167-58.2-56.174-58.2z",
    className: "Default-Empty-State-View_svg__cls-6",
    transform: "translate(-614.016 -345.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_626-2",
    d: "M660.607 401.962l-2.427 21.883a18.707 18.707 0 009.566 2.478 27.639 27.639 0 0011.463-2.665l-.718-8.287h-.274c-13.266.002-17.61-13.409-17.61-13.409z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-610.634 -329.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_627-2",
    d: "M677.32 386.249l-19.594 1.951-1.887 2.329s5.482 14.526-4.763 16.574c0 0 4.072 14.265 18.736 14.265q1.108 0 2.294-.112s4.045-1.489 5.574-8.1c1.437-6.608 1.62-16.29-.36-26.907z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-601.099 -334.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_628-2",
    d: "M658.319 401.962c2.655 18.294 17 18.719 18.326 18.719h.1l-.45-4.281c-14.74-1.774-17.976-14.436-17.976-14.438z",
    className: "Default-Empty-State-View_svg__cls-8",
    transform: "translate(-608.344 -329.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_629-2",
    d: "M690.83 370.537c-1.181 3.259-4.748 5.031-11.89 5.031a71.442 71.442 0 01-9.5-.75 27.056 27.056 0 00-3.778-.284c-10.214 0-11.232 7.082-11.232 7.082-7.28.653-5.662 6.986-5.662 6.986a3.866 3.866 0 00-.9-.109c-2.582 0-4.039 2.715-4.039 2.715a4.067 4.067 0 011.706-.445c1.761 0 2.577 1.809 2.789 4.357a15.159 15.159 0 002.7 7.264c.841 1.418.135 1.78-.8 1.78a8.639 8.639 0 01-2.168-.385 11.548 11.548 0 0011.445 8.5c.434 0 .688-.026.688-.026l4.851-16.574s1.708-2.236 12.314-2.236c10.516-.094 11.415-.094 17.078-5.96 5.75-5.958.718-15.176.718-15.179a4.046 4.046 0 01-3.685 4.656 6.365 6.365 0 00-.635-6.423z",
    className: "Default-Empty-State-View_svg__cls-17",
    transform: "translate(-610.206 -339.557)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_630-2",
    d: "M672.64 372.962a12.56 12.56 0 00-9.546 3.857c-6.649 7.077-6.022 14.526-6.022 14.526l4.226-.56s.221-15.957 13.058-15.957a19.2 19.2 0 014.2.5l2.426-.651a22.793 22.793 0 00-8.342-1.715z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-610.962 -338.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_631-2",
    fill: "#3b135e",
    fillRule: "evenodd",
    d: "M650.958 386.671a6.349 6.349 0 01-2.427.838 57.373 57.373 0 011.078 13.594c.99-.094 3.776-4 3.326-8.381a11.766 11.766 0 00-1.977-6.051z",
    transform: "translate(-572.042 -334.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_632-2",
    d: "M665 385.884a5.717 5.717 0 00-1.125.112c-4.223.838-6.74 6.239-5.663 12.011.977 5.336 4.675 9.128 8.491 9.128h.139a14.733 14.733 0 0012.674 9.685 1.65 1.65 0 001.618 1.21l2.515-.279c2.1-.182 1.816-3.36-.189-3.36-.055 0-.113 0-.171.008l-2.517.279a1.419 1.419 0 00-.987.466 12.79 12.79 0 01-11.144-7.727c-.091-.187-.091-.375-.181-.56 3.776-1.21 6.022-6.332 4.944-11.827-.986-5.346-4.581-9.146-8.404-9.146z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-616.235 -334.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2811",
    transform: "translate(22.712 227.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_593",
    d: "M291.661 351.583a38.978 38.978 0 11-38.979 38.978 38.992 38.992 0 0138.979-38.978z",
    className: "Default-Empty-State-View_svg__cls-6",
    transform: "translate(-252.683 -351.583)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2810",
    transform: "translate(24.335 15.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_594",
    d: "M289.973 397.514s2.995 8.922 12.127 8.922h.284l.5 5.55c-.561 5.238-6.8 7.609-6.8 7.609a13.6 13.6 0 01-6.237-7.8z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-281.14 -371.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_596",
    d: "M289.988 397.514s2.245 8.419 12.472 9.668l.312 2.869h-.044c-.757 0-10.88-.232-12.74-12.537z",
    className: "Default-Empty-State-View_svg__cls-19",
    transform: "translate(-281.156 -371.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_595",
    d: "M294.542 376.751l13.658 4.49c1.372 7.11 1.248 13.6.249 18.024-1.06 4.428-3.866 5.426-3.866 5.426a14.357 14.357 0 01-2.179.173c-9.18 0-12.415-9.654-12.415-9.654 7.11-1.372 3.305-11.163 3.305-11.163z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-281.156 -369.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_597",
    fill: "#126bd5",
    fillRule: "evenodd",
    d: "M292.931 369.095a20.971 20.971 0 012.317.134 61.177 61.177 0 007.546.436c2.494.624 6.612 3.617 7.8 12.474.748 5.737-1.123 12.6-.812 28.065l-7.8-.811-.748-5.427c.112.007.221.009.331.009a4.937 4.937 0 002.787-.819 9.643 9.643 0 003.118-5.426c1.559-7.8 0-16.4 0-16.4-1.311.124-4.49.373-6.735.373-1 0-1.872.063-2.62.063l-1.558-4.3-.438 4.551c-3.242.438-3.929 1.185-3.929 1.185l-3.431 25.445-8.606 1.56v-17.155c.002-5.944-2.095-23.957 12.778-23.957z",
    transform: "translate(-280.054 -368.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_3011",
    d: "M297.722 368.5a16.461 16.461 0 015.838 1.159l-1.684.375a13.806 13.806 0 00-2.852-.321c-8.967 0-9.122 10.736-9.122 10.736l-2.932.373s-.436-5.052 4.18-9.791a8.875 8.875 0 016.572-2.531z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-280.819 -368.503)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_3012",
    d: "M288.42 381.368c2.66 0 5.16 2.594 5.843 6.124.748 3.68-.81 7.108-3.43 7.982a1.052 1.052 0 01.126.312 9.134 9.134 0 007.733 5.238 1.435 1.435 0 01.75-.373l1.684-.125c.038 0 .078-.005.117-.005a1.171 1.171 0 011.13 1 1.222 1.222 0 01-1.06 1.246l-1.684.126a1.033 1.033 0 01-.127.007 1.151 1.151 0 01-1.058-.756 10.118 10.118 0 01-8.731-6.485h-.1c-2.648 0-5.212-2.538-5.89-6.113-.75-3.929 1-7.546 3.929-8.107a4.1 4.1 0 01.768-.071z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-280.442 -369.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_3013",
    d: "M312.365 382.223a7.667 7.667 0 011.372 3.992c.312 2.993-1.621 5.55-2.306 5.674a37.209 37.209 0 00-.75-9.1 5.965 5.965 0 001.684-.566z",
    className: "Default-Empty-State-View_svg__cls-10",
    transform: "translate(-283.451 -370.024)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2815",
    transform: "translate(372.083 45.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Rectangle_759",
    fill: "#fff",
    stroke: "#707070",
    transform: "translate(24.58 92.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__fill",
    stroke: "none",
    d: "M0 0h.598v.598H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .098h.598M.5 0v.598M.598.5H0m.098.098V0",
    clipPath: "url(#Default-Empty-State-View_svg__clip)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_607",
    fill: "rgba(0,0,0,0)",
    fillRule: "evenodd",
    d: "M685 242.891a42.876 42.876 0 11-42.845-42.907A42.878 42.878 0 01685 242.891z",
    transform: "translate(-599.252 -199.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_609",
    d: "M642.614 204.368a38.978 38.978 0 1038.979 38.978 38.992 38.992 0 00-38.979-38.978z",
    className: "Default-Empty-State-View_svg__cls-6",
    transform: "translate(-599.739 -200.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_611",
    d: "M647.061 229.536l-13.657 4.49c-1.372 7.11-1.248 13.6-.249 18.024 1.06 4.428 3.866 5.426 3.866 5.426a14.376 14.376 0 002.179.173c9.179 0 12.414-9.654 12.414-9.654-7.11-1.372-3.3-11.163-3.3-11.163z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-602.929 -203.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_613",
    d: "M647.239 221.88a20.972 20.972 0 00-2.317.134 61.187 61.187 0 01-7.546.436c-2.495.624-6.612 3.617-7.8 12.474-.748 5.737 1.123 12.6.812 28.064l7.8-.811.748-5.426a5.265 5.265 0 01-.331.009 4.937 4.937 0 01-2.787-.819 9.643 9.643 0 01-3.118-5.426c-1.558-7.8 0-16.4 0-16.4 1.311.124 4.49.373 6.735.373 1 0 1.872.063 2.62.063l1.558-4.3.437 4.551c3.242.438 3.929 1.185 3.929 1.185l3.431 25.445 8.606 1.56v-17.155c-.002-5.944 2.095-23.957-12.777-23.957z",
    className: "Default-Empty-State-View_svg__cls-17",
    transform: "translate(-602.597 -202.414)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Default-Empty-State-View_svg__Group_2812",
    transform: "translate(27.198 18.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_610",
    d: "M652.4 250.3s-2.995 8.921-12.127 8.921h-.284l-.5 5.55c.561 5.238 6.8 7.609 6.8 7.609a13.6 13.6 0 006.237-7.8z",
    className: "Default-Empty-State-View_svg__cls-7",
    transform: "translate(-630.915 -224.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_612",
    d: "M652.418 250.3s-2.245 8.419-12.472 9.668l-.312 2.869h.044c.757-.001 10.88-.237 12.74-12.537z",
    className: "Default-Empty-State-View_svg__cls-19",
    transform: "translate(-630.93 -224.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Union_64",
    fill: "url(#Default-Empty-State-View_svg__linear-gradient-10)",
    d: "M3.555 32.965l-1.684-.125a1.222 1.222 0 01-1.059-1.246 1.17 1.17 0 011.129-1h.117l1.684.126a1.438 1.438 0 01.75.373 9.133 9.133 0 007.733-5.238 1.035 1.035 0 01.125-.311c-2.62-.874-4.178-4.3-3.431-7.982.587-3.027 2.509-5.366 4.722-5.97-.123-1.864-1.12-10.378-9.1-10.378a13.808 13.808 0 00-2.852.321L0 1.159A16.464 16.464 0 015.837 0a8.875 8.875 0 016.572 2.532 13.9 13.9 0 014.19 9.342c2.27 1.135 3.512 4.321 2.859 7.744-.679 3.576-3.242 6.114-5.891 6.114h-.1a10.118 10.118 0 01-8.727 6.484 1.151 1.151 0 01-1.058.756 1 1 0 01-.127-.007z",
    transform: "translate(7.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Default-Empty-State-View_svg__Path_615",
    d: "M631.251 235.008a7.666 7.666 0 00-1.372 3.992c-.312 2.993 1.621 5.55 2.306 5.674a37.218 37.218 0 01.75-9.1 5.964 5.964 0 01-1.684-.566z",
    className: "Default-Empty-State-View_svg__cls-9",
    transform: "translate(-629.845 -222.81)"
  }))))))));
};
export default SvgDefaultEmptyStateView;